import { AlertCircle } from 'lucide-react';
import { motion } from 'motion/react';
import { Link } from 'react-router-dom';
import { BloggerPost } from '../services/mockData';

export function BreakingNewsTicker({ news, speed = 45, delay = 0 }: { news: BloggerPost[], speed?: number, delay?: number }) {
  if (!news || news.length === 0) {
    return (
      <div className="flex items-center bg-[#F9F9F9] dark:bg-gray-800 px-4 py-2.5 h-[41px] border-b border-gray-100 dark:border-gray-700 overflow-hidden">
        <div className="flex items-center text-[#D32F2F] mr-3 shrink-0 z-10 bg-[#F9F9F9] dark:bg-gray-800">
          <AlertCircle size={16} className="mr-1.5 animate-pulse" />
          <span className="text-[11px] font-bold uppercase tracking-wider font-bengali">ব্রেকিং</span>
        </div>
        <div className="flex-1 overflow-hidden relative h-5 flex items-center border-l-2 border-red-200 dark:border-red-900/50 pl-3">
          <motion.div
            className="whitespace-nowrap text-sm font-medium font-bengali text-[#111111] dark:text-gray-100 absolute left-0 flex items-center w-max"
            initial={{ x: 0 }}
            animate={{ x: "-50%" }}
            transition={{ ease: 'linear', duration: speed, delay: delay, repeat: Infinity, repeatType: 'loop' }}
          >
            <span className="pr-8">শীঘ্রই আরও খবর আসছে...</span>
            <span>শীঘ্রই আরও খবর আসছে...</span>
          </motion.div>
        </div>
      </div>
    );
  }

  const renderNewsItems = () => (
    <>
      {news.map((n, i) => {
        const priority = (n as any).priority || 'normal';
        let badge = null;
        if (priority === 'flash') {
            badge = <span className="bg-red-600 text-white px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider mr-2 animate-pulse shrink-0">Flash</span>;
        } else if (priority === 'high') {
            badge = <span className="bg-orange-500 text-white px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider mr-2 shrink-0">High</span>;
        }

        return (
          <span key={`${n.id}-${i}`} className="flex items-center pr-8">
            {badge}
            {(n as any).isCustom ? (
              <span className={`hover:text-[#D32F2F] cursor-default ${priority === 'flash' ? 'text-red-600 font-bold dark:text-red-400' : ''}`}>
                {n.title}
              </span>
            ) : (
              <Link to={n.url ? new URL(n.url).pathname : `/post/${n.id}`} className="hover:text-[#D32F2F] hover:underline">
                {n.title}
              </Link>
            )}
            <span className="mx-4 text-gray-500">•</span>
          </span>
        );
      })}
    </>
  );

  return (
    <div className="flex items-center bg-[#F9F9F9] dark:bg-gray-800 px-4 py-2.5 h-[41px] border-b border-gray-100 dark:border-gray-700 overflow-hidden">
      <div className="flex items-center text-[#D32F2F] mr-3 shrink-0 z-10 bg-[#F9F9F9] dark:bg-gray-800">
        <AlertCircle size={16} className="mr-1.5 animate-pulse" />
        <span className="text-[11px] font-bold uppercase tracking-wider font-bengali">ব্রেকিং</span>
      </div>
      <div className="flex-1 overflow-hidden relative h-5 flex items-center border-l-2 border-red-200 dark:border-red-900/50 pl-3">
        <motion.div
          className="whitespace-nowrap text-sm font-medium font-bengali text-[#111111] dark:text-gray-100 absolute left-0 flex items-center w-max"
          initial={{ x: 0 }}
          animate={{ x: "-50%" }}
          transition={{ ease: 'linear', duration: speed, delay: delay, repeat: Infinity, repeatType: 'loop' }}
        >
          {renderNewsItems()}
          {renderNewsItems()}
        </motion.div>
      </div>
    </div>
  );
}
